import { FC } from 'react';
import styled from '@emotion/styled';
import { mediaQuery, Spacings } from '@styles/index';
import Button from 'aquilla/core/molecules/Button';
import useGateXeRedirect from './useGateXeRedirect';

type StyledButtonProps = {
  $isRedirecting: boolean;
};

const StyledButton = styled(Button)<StyledButtonProps>`
  width: 160px;
  pointer-events: ${({ $isRedirecting }) => ($isRedirecting ? 'none' : 'auto')};
  height: ${Spacings.SPACING_12B};
  margin-top: ${Spacings.SPACING_6B};

  ${mediaQuery.uptoMobile} {
    width: 100%;
  }
`;

type GateXeGoToTestButtonProps = {
  skuUid: string | null;
};

const GateXeGoToTestButton: FC<GateXeGoToTestButtonProps> = ({ skuUid }) => {
  const { goToTest, isRedirecting } = useGateXeRedirect(skuUid);

  return (
    <StyledButton
      variant="primary"
      size="large"
      label="Go to test"
      isLoading={isRedirecting}
      $isRedirecting={isRedirecting}
      onClick={isRedirecting ? undefined : goToTest}
    />
  );
};

export default GateXeGoToTestButton;
